<template>
  <div
    class="page-template add-page"
    v-loading="loading"
  >
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="audit(3)" type="primary" plain :disabled="formModel.reviewerStatus === null">审核</el-button>
      <el-button @click="customerChange" type="primary" plain>批发查询</el-button>
    </div>
    <list-operation-form
      ref="listOperationForm"
      :formOptions="listFormOptions"
      @valueChange="listFormValueChange">
    </list-operation-form>
    <list-operation ref="listOperation" :tableOptions="listColumns"
                    @selectRowChange="selectShowChange"></list-operation>
  </div>
</template>
<script>
  //添加要货单组件
  import listOperation from "@/components/template/listOperation";
  //要货单搜索组件
  import listOperationForm from "@/components/template/listOperationForm";
  import api from "@/config/api";
  // 数据权限
  import userPower from "@/mixin/userPower";

  export default {
    mixins: [userPower],
    components: {
      listOperation,
      listOperationForm,
    },
    data() {
      return {
        isExistNullPrince: 0,
        formModel: {reviewerStatus: null},
        loading: false,
        title: "",
        listShow: false,
        dialogShow: false,
        //头部条件
        listFormOptions: {
          disabled: false,
          statusOption: {
            prop: "reviewerStatus",
            statusImg: {
              10: "/static/checked.png",
              20: "/static/un-check.png",
            },
          },
          labelWidth: "130px",
          columns: [
            {
              prop: "id",
              hidden: true,
            },
            {
              label: "业务单号",
              type: "input",
              prop: "orderNo",
              span: 8,
              disabled: true,
            },
            {
              label: "门店",
              type: "storeInputDialog",
              prop: "storeId",
              disabled: false,
              isHasAll: true,
              span: 8,
            },
            {
              label: "客户",
              type: "wholesaleCustomerInputDialog",
              prop: "customerId",
              data: [],
              span: 8,
              // change: this.customerChange,
              rule: [
                {required: true, message: "请选择客户", trigger: "change"},
              ],
            },
            {
              label: "单据金额",
              prop: "billAmount",
              type: "input",
              span: 8,
              disabled: true,
            },
            {
              label: "备注",
              type: "input",
              prop: "remarks",
              span: 8,
            },
          ],
        },
        // 添加表格字段
        listColumns: {
          height: this.height,
          summaryColumns: ["payAmount"],
          showSelect: true,
          disabled: false,
          columns: [
            {label: "序号", type: "index", width: 80, prop: "idx"},
            {
              label: "单据号",
              prop: "wholesaleOrderNo",
              width: "180",
              align: "center",
              callback: this.goOrderDetail,
            },
            // {
            //   label: "门店编码",
            //   prop: "storeCode",
            //   width: "120",
            //   align: "center",
            // },
            {
              label: "门店名称",
              prop: "storeName",
              width: "90",
              align: "center",
            },
            {
              label: "单据类型",
              width: "90",
              prop: "type",
              align: "center",
              enumData: this.$utils.getCacheStatus("stCustomerBillMap.type"),
            },
            {
              label: "单据日期",
              width: "125",
              prop: "wholesaleDttm",
              align: "center",
            },
            {
              label: "应收金额",
              width: "90",
              prop: "payAmount",
              align: "center",
            },
            {
              label: "备注",
              type: 'input',
              prop: "remarks",
              width: "200",
              align: "center",
            },
          ],
        },
        checkIndex: "",
        salesDetailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '350px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              span: 12,
            }, {
              label: '批发客户',
              prop: 'wholesaleCustomerName',
              span: 12,
            }, {
              label: '仓库',
              prop: 'warehouseName',
              span: 12,
            }, {
              label: '经手人',
              prop: 'salesman',
              span: 12
            }, {
              label: '备注',
              prop: 'remarks',
              span: 12,
            }],
          tablesProp: {
            wlWholesaleOrderGoodsMapList: {
              summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
              tableName: "wlWholesaleOrderGoodsMapList",
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '125',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsCount',
                  align: "center"
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsCount',
                  align: "center"
                },
                {
                  label: '原价',
                  width: '90',
                  prop: 'beforePrince',
                  align: "center"
                },
                {
                  label: '原价金额',
                  width: '90',
                  prop: 'beforeAmt',
                  align: "center"
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: "center"
                },
                {
                  label: '折扣价格',
                  width: '90',
                  prop: 'discountPrince',
                  align: "center"
                },
                {
                  label: '小计金额',
                  width: '90',
                  prop: 'discountAmt',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },

          // 打印的列表
          printTablesProp: {
            wlWholesaleOrderGoodsMapList: {
              tableName: 'wlWholesaleOrderGoodsMapList',
              showSummary: true,
              summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '125',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsCount',
                  align: "center"
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsCount',
                  align: "center"
                },
                {
                  label: '原价',
                  width: '90',
                  prop: 'beforePrince',
                  align: "center"
                },
                {
                  label: '原价金额',
                  width: '90',
                  prop: 'beforeAmt',
                  align: "center"
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: "center"
                },
                {
                  label: '折扣价格',
                  width: '90',
                  prop: 'discountPrince',
                  align: "center"
                },
                {
                  label: '小计金额',
                  width: '90',
                  prop: 'discountAmt',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.wholesale.wholesaleSales
        },
        returnDetailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '350px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              span: 12,
            }, {
              label: '批发客户',
              prop: 'wholesaleCustomerName',
              span: 12,
            }, {
              label: "仓库",
              prop: "warehouseName",
              span: 12,
            }, {
              label: '经手人',
              prop: 'salesman',
              span: 12
            },
            {
              label: '批发销售单',
              type: 'select',
              prop: 'wholesaleOrderNo',
              span: 12,
            }, {
              label: '备注',
              prop: 'remarks',
              span: 12,
            }],
          tablesProp: {
            wlWholesaleOrderGoodsMapList: {
              tableName: "wlWholesaleOrderGoodsMapList",
              summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '125',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsCount',
                  type: 'inputNumber',
                  align: "center"
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsCount',
                  align: "center"
                },
                {
                  label: '原价',
                  width: '90',
                  prop: 'beforePrince',
                  align: "center"
                },
                {
                  label: '原价金额',
                  width: '90',
                  prop: 'beforeAmt',
                  align: "center"
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: "center"
                },
                {
                  label: '折扣价格',
                  width: '90',
                  prop: 'discountPrince',
                  align: "center"
                },
                {
                  label: '小计金额',
                  width: '90',
                  prop: 'discountAmt',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },

          // 打印的列表
          printTablesProp: {
            wlWholesaleOrderGoodsMapList: {
              tableName: 'wlWholesaleOrderGoodsMapList',
              showSummary: true,
              summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '125',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsCount',
                  type: 'inputNumber',
                  align: "center"
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsCount',
                  align: "center"
                },
                {
                  label: '原价',
                  width: '90',
                  prop: 'beforePrince',
                  align: "center"
                },
                {
                  label: '原价金额',
                  width: '90',
                  prop: 'beforeAmt',
                  align: "center"
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: "center"
                },
                {
                  label: '折扣价格',
                  width: '90',
                  prop: 'discountPrince',
                  align: "center"
                },
                {
                  label: '小计金额',
                  width: '90',
                  prop: 'discountAmt',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.wholesale.wholesaleReturn
        }
      };
    },
    beforeCreate() {
      this.height = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.setStoreId(this.listFormOptions.columns);
      this.title = (this.$route.query.id ? "编辑" : "新增") + document.title;
      if (this.$route.query.id) {
        this.getDetail();
      }
    },
    methods: {
      listFormValueChange(value, column) {
        if (column.prop == "storeId") {
          this.$refs.listOperationForm.$refs.wholesaleCustomerInputDialog[0].initData();
          this.$refs.listOperationForm.formModel.customerId = "";
          this.$refs.listOperationForm.formModel.storeId = value.id;
          this.$refs["listOperation"].clearTableData();
          this.listFormOptions.columns.filter(
            item => item.prop === "customerId"
          )[0].params = {storeId: value.id};
        }
        if (column.prop == "customerId") {
          this.$refs["listOperation"].clearTableData();
        }
      },
      goOrderDetail(row) {
        console.log(row);
        if (row.type === 50) {
          this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.salesDetailColumns);
          const {href} = this.$router.resolve({
            name: "SalesDetail",
            query: {id: row.wholesaleId},
          });
          window.open(href, "_blank");
        } else {
          this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.returnDetailColumns);
          const {href} = this.$router.resolve({
            name: "wholeasleReturnDetail",
            query: {id: row.wholesaleId},
          });
          window.open(href, "_blank");
        }

      },
      //编辑
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.settle.billCustomer + "?id=" + this.$route.query.id, {})
          .then((data) => {
            this.formModel = data.data;
            if (this.formModel.reviewerStatus === 10) {
              this.listFormOptions.disabled = true;
              this.listColumns.disabled = true;
            }
            this.loading = false;
            if (data.code === 200) {
              this.listFormOptions.columns.filter(
                (item) => item.prop === "customerId"
              )[0].disabled = true;
              this.listFormOptions.columns.filter(
                (item) => item.prop === "storeId"
              )[0].disabled = true;
              //为头部表单赋值
              this.$refs.listOperationForm.formModel = data.data;
              if (data.data.storeId === null) {
                this.$refs.listOperationForm.formModel.storeId = "";
              }
              //为表格赋值
              this.$refs["listOperation"].addMoreRow(
                data.data.stCustomerBillMapMVOList,
                0
              );
              this.$nextTick(() => {
                this.$refs["listOperation"].selectAll();
              });
            } else {
              this.$message({message: data.msg, type: "error"});
            }
          })
          .catch((err) => {
            this.$message({message: "请求失败！", type: "error"});
            this.loading = false;
          });
      },

      //提交数据
      submitAuth(e) {
        //获取选择的list数据
        let tableList = this.$refs["listOperation"].selectRows;
        //将合计的值重新赋值给后端接收的参数
        let totalParam = this.$refs["listOperation"].getSumData();
        //将表头的值重新赋值给后端接收的参数
        let headParam = this.$refs.listOperationForm.getFormModel();
        headParam.reviewerStatus = 20;
        let searchParam = {
          ...{stCustomerBillMapList: tableList},
          ...totalParam,
          ...headParam,
        };
        if (tableList.length === 0) {
          this.$message({message: "请勾选数据！", type: "warning"});
        } else {
          if (tableList[tableList.length - 1].id !== undefined) {
            this.saveData(headParam, e, searchParam);
          } else {
            this.$message({message: "请勿勾选合计数据！", type: "warning"});
          }
        }
      },

      saveData(headParam, e, searchParam) {
        if (headParam.id) {
          if (e === 3) {
            this.$confirm("是否确认审核?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.handleRequest(
                  this.$axios.fetchPost(
                    api.settle.billCustomer + "/bill/audit",
                    searchParam
                  ),
                  e
                );
              })
              .catch(() =>
                this.$message({message: "审核取消！", type: "info"})
              );
          } else {
            this.$confirm("是否确认保存?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.handleRequest(
                  this.$axios.fetchPut(api.settle.billCustomer, searchParam),
                  e
                );
              })
              .catch(() =>
                this.$message({message: "保存取消！", type: "info"})
              );
          }
        } else {
          this.$confirm("是否确认保存?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.handleRequest(
                this.$axios.fetchPost(api.settle.billCustomer, searchParam),
                e
              );
            })
            .catch(() => this.$message({message: "保存取消！", type: "info"}));
        }
      },
      //处理添加和编辑的请求
      handleRequest(parm, e) {
        parm
          .then((data) => {
            this.loading = false;
            if (data.code === 200) {
              if (e === 3) {
                this.$notify({
                  type: "success",
                  title: '审核操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: "审核成功！", type: "success"});
                this.$router.push({path: "/bill/customer"});
              } else {
                this.$notify({
                  type: "success",
                  title: '保存操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: "保存成功！", type: "success"});
                this.dialogShow = false;
                this.$refs.listOperationForm.formModel = data.data;
                this.formModel.reviewerStatus = data.data.reviewerStatus;
              }
            } else {
              if (e === 3) {
                this.$notify({
                  type: "error",
                  title: '审核操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: "审核失败！", type: "error"});
              } else {
                this.$notify({
                  type: "error",
                  title: '保存操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: "保存失败！", type: "error"});
              }
            }
          })
          .catch((err) => {
            this.$message({message: "请求失败！", type: "error"});
            this.loading = false;
          });
      },

      //返回按钮事件
      beBack() {
        this.$router.go(-1);
      },
      refresh(e) {
        this.$router.go(0);
      },
      // 审核
      audit(e) {
        this.submitAuth(e);
      },
      //选择门店
      storeChange(form) {
        if (this.$refs["listOperation"]) {
          this.$refs["listOperation"].clearTableData();
        }
        form.customerId = ''
        // if (form.storeId) {
        this.$axios.fetchPost(api.wholesale.archives + "/list", {storeId: form.storeId,}).then((data) => {
          if (data.code === 200) {
            this.listFormOptions.columns.filter(
              (item) => item.prop === "customerId"
            )[0].data = data.data;
          } else {
            this.$message({message: "门店获取客户失败", type: "error"});
          }
        });
        // }
      },
      customerChange() {
        let form = this.$refs.listOperationForm.getFormModel();
        if (!form.storeId) {
          this.$message.warning("请选择门店");
          return;
        }
        if (!form.customerId) {
          this.$message.warning("请选择客户")
          return;
        }
        if (form.customerId) {
          this.$refs["listOperation"].clearTableData();
          this.$axios
            .fetchPost(api.settle.wholesaleOrder, {
              customerId: form.customerId,
              storeId: form.storeId
            })
            .then((data) => {
              if (data.code === 200) {
                if (data.data.length > 0) {
                  //为表格赋值
                  data.data.map((item, index) => {
                    item.id = index + 1;
                  });
                  this.$refs["listOperation"].addMoreRow(data.data, 0);
                } else {
                  this.$message({message: "此客户无单据数据", type: "warning"});
                }
              } else {
                this.$message({message: "客户获取批发单失败", type: "error"});
              }
            });
        }
      },
      selectShowChange(selectRows) {
        let billAmount = 0;
        selectRows.map((item) => {
          billAmount = billAmount + parseFloat(item.payAmount);
        });
        this.$refs.listOperationForm.formModel.billAmount = billAmount.toFixed(2);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/page/settle/customer/BillCustomerAdd.vue